module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer",
    staticStyle: {
      "width": "100%",
      "height": "160px"
    }
  }, [_c('div', {
    staticClass: "yueyun-footer yueyun-footer-left"
  }, [_c('div', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('p', [_vm._v("广东粤运交通股份有限公司 版权所有")]), _vm._v(" "), _c('p', [_vm._v("建议使用IE9.0以上浏览器 1366*768分辨率")])])]), _vm._v(" "), _c('div', {
    staticClass: "yueyun-footer yueyun-footer-right"
  }, [_c('div', {
    staticClass: "yueyun-footer-div1"
  }, [_c('h4', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("关注我们")]), _vm._v(" "), _c('p', [_c('img', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "src": "static/imgs/phoneIcon.png",
      "alt": ""
    }
  }), _c('span', {
    staticClass: "icon-fix"
  }, [_vm._v("020-32318100")])]), _vm._v(" "), _c('p', [_c('img', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "src": "static/imgs/addressIcon.png",
      "alt": ""
    }
  }), _c('span', {
    staticClass: "icon-fix"
  }, [_vm._v("广州市中山二路3号粤运大厦")])])]), _vm._v(" "), _c('div', {
    staticClass: "yueyun-footer-div2"
  }, [_c('table', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "cellspacing": "10"
    }
  }, [_c('tr', [_c('td', [_vm._v("\n              悦行APP\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              微信公众号\n            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": "static/imgs/yueyunapp1.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('td', [_c('img', {
    attrs: {
      "src": "static/imgs/yueyunweixin.png",
      "alt": ""
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64ed4812","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/G-footer.vue
// module id = 26
// module chunks = 1 5 6 7 8 9 10 11 12 13 14 15